"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Appointment Experience API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogAppointmentActivityRequestActionEnum = exports.LogAppointmentActivityRequestActivityTypeEnum = void 0;
/**
 * @export
 * @enum {string}
 */
var LogAppointmentActivityRequestActivityTypeEnum;
(function (LogAppointmentActivityRequestActivityTypeEnum) {
    LogAppointmentActivityRequestActivityTypeEnum["CareNote"] = "care-note";
    LogAppointmentActivityRequestActivityTypeEnum["Assessment"] = "assessment";
    LogAppointmentActivityRequestActivityTypeEnum["Task"] = "task";
    LogAppointmentActivityRequestActivityTypeEnum["Appointment"] = "appointment";
})(LogAppointmentActivityRequestActivityTypeEnum = exports.LogAppointmentActivityRequestActivityTypeEnum || (exports.LogAppointmentActivityRequestActivityTypeEnum = {}));
/**
 * @export
 * @enum {string}
 */
var LogAppointmentActivityRequestActionEnum;
(function (LogAppointmentActivityRequestActionEnum) {
    LogAppointmentActivityRequestActionEnum["Started"] = "started";
    LogAppointmentActivityRequestActionEnum["Updated"] = "updated";
    LogAppointmentActivityRequestActionEnum["Completed"] = "completed";
})(LogAppointmentActivityRequestActionEnum = exports.LogAppointmentActivityRequestActionEnum || (exports.LogAppointmentActivityRequestActionEnum = {}));
